import { render } from "./ProductSegmentEditAll.vue?vue&type=template&id=2f29e562&scoped=true"
import script from "./ProductSegmentEditAll.vue?vue&type=script&lang=js"
export * from "./ProductSegmentEditAll.vue?vue&type=script&lang=js"

import "./ProductSegmentEditAll.vue?vue&type=style&index=0&id=2f29e562&lang=scss&scoped=true"

import exportComponent from "/var/www/likvio.se/html-prod/likvio-fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f29e562"]])

export default __exports__